import React, { Fragment, FC } from 'react'

import StrikethroughPrice from './StrikethroughPrice'
import BoldPrice from './BoldPrice'

type Props = {
  price: number
  sellingPrice: number
  quantity: number
  index: number
}

const DiscountPrice: FC<Props> = ({ price, sellingPrice, quantity, index }) => {
  return (
    <Fragment>
      <StrikethroughPrice price={price * quantity} />
      <span id={`productlistitem-${index}-price`}>
        <BoldPrice value={sellingPrice * quantity} />
      </span>
    </Fragment>
  )
}

export default DiscountPrice
